const MissionCard = () => {
  return (
    <div className="card missionCard">
      <div className="cardTitle missionTitle">Our Mission</div>
      <div className="linksText">
        Better horse care through research and education.
      </div>
      <div className="linksLink">
        <a href="https://esc.rutgers.edu/" target="_blank" rel="noreferrer">
          esc.rutgers.edu
        </a>
      </div>
      <div className="linksLink">
        <a href="https://njaes.rutgers.edu/" target="_blank" rel="noreferrer">
          njaes.rutgers.edu
        </a>
      </div>
    </div>
  )
}

export default MissionCard
